var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "addTemplate" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "searchBox" },
          [
            _c(
              "div",
              { staticClass: "searchBox_top" },
              [
                !_vm.taskApproval && _vm.isSubmit
                  ? [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.Sensory - _vm.templateSave,
                              expression: "Sensory-templateSave",
                            },
                          ],
                          key: "save",
                          attrs: { type: "primary" },
                          on: { click: _vm.save },
                        },
                        [_vm._v(_vm._s(_vm.$t("visitPlan.draftSave")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.Sensory - _vm.templateSave,
                              expression: "Sensory-templateSave",
                            },
                          ],
                          key: "submit",
                          attrs: { type: "primary" },
                          on: { click: _vm.submit },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.submit")))]
                      ),
                    ]
                  : _vm._e(),
                _vm.taskApproval
                  ? [
                      _c(
                        "el-button",
                        {
                          key: "pass",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.pass()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("visitPlan.ApprovalPass")))]
                      ),
                      _c(
                        "el-button",
                        {
                          key: "reject",
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.refuseVisible = true
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("visitPlan.ApprovalReject")))]
                      ),
                    ]
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.historyBack },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.close")))]
                ),
                !_vm.taskApproval && _vm.isSubmit
                  ? [
                      _c("br"),
                      _c(
                        "label",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            color: "#F56C6C",
                            clear: "both",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("visitPlan.operationTips")))]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _c(
              "el-form",
              {
                ref: "queryCondition",
                attrs: {
                  model: _vm.queryCondition,
                  "label-width": "150px",
                  rules: _vm.queryConditionRules,
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: "6" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "sensory.template.SensoryReporttemplateNo"
                              ),
                              prop: "templateNo",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "保存后显示",
                                disabled: "",
                              },
                              model: {
                                value: _vm.queryCondition.templateNo,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "templateNo",
                                    $$v
                                  )
                                },
                                expression: "queryCondition.templateNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: "6" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("sensory.template.name"),
                              prop: "templateName",
                            },
                          },
                          [
                            _c(
                              "el-input",
                              {
                                staticClass: "handle-input",
                                attrs: { disabled: !_vm.isSubmit },
                                model: {
                                  value: _vm.queryCondition.templateName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "templateName",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.templateName",
                                },
                              },
                              [
                                _c("el-button", {
                                  staticClass: "search_btn",
                                  attrs: {
                                    slot: "append",
                                    icon: "el-icon-search",
                                    disabled: !_vm.isSubmit,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.showTemplateName(_vm.isSubmit)
                                    },
                                  },
                                  slot: "append",
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: "6" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("visitPlan.Remark"),
                              prop: "remark",
                            },
                          },
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top-start",
                                  disabled: !_vm.showPopover,
                                  width: "280",
                                  trigger: "hover",
                                  content: _vm.queryCondition.remark,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    slot: "reference",
                                    disabled: !_vm.isSubmit,
                                    clearable: "",
                                    maxlength: "200",
                                  },
                                  slot: "reference",
                                  model: {
                                    value: _vm.queryCondition.remark,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryCondition,
                                        "remark",
                                        $$v
                                      )
                                    },
                                    expression: "queryCondition.remark",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: "6" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("sensory.template.createTime"),
                              prop: "createDate",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                value: _vm._f("dateFormatFilter")(
                                  _vm.queryCondition.createDate,
                                  "YYYY-MM-DD"
                                ),
                                disabled: "",
                                clearable: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: "6" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("sensory.template.createBy"),
                              prop: "creator",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.queryCondition.creator,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "creator", $$v)
                                },
                                expression: "queryCondition.creator",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: "12" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("sensory.template.modules"),
                            },
                          },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                disabled: !_vm.isSubmit,
                                label: "Appearance",
                              },
                              model: {
                                value: _vm.queryCondition.showAppearance,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "showAppearance",
                                    $$v
                                  )
                                },
                                expression: "queryCondition.showAppearance",
                              },
                            }),
                            _c("el-checkbox", {
                              attrs: {
                                disabled: !_vm.isSubmit,
                                label: "Texture",
                              },
                              model: {
                                value: _vm.queryCondition.showTexture,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "showTexture",
                                    $$v
                                  )
                                },
                                expression: "queryCondition.showTexture",
                              },
                            }),
                            _c("el-checkbox", {
                              attrs: {
                                disabled: !_vm.isSubmit,
                                label: "Flavor",
                              },
                              model: {
                                value: _vm.queryCondition.showFlavor,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "showFlavor",
                                    $$v
                                  )
                                },
                                expression: "queryCondition.showFlavor",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-tabs",
          {
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "模板明细", name: "first" } },
              [
                _c(
                  "el-form",
                  {
                    ref: "formTable",
                    attrs: {
                      rules: _vm.formTableRules,
                      model: _vm.formTable,
                      inline: "",
                    },
                  },
                  [
                    _vm.queryCondition.showAppearance
                      ? [
                          _c(
                            "div",
                            { staticClass: "table_title" },
                            [
                              _c("div", { staticClass: "table_title_sub c1" }, [
                                _vm._v("Appearance"),
                              ]),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "appearanceDesc",
                                  attrs: {
                                    label: "APPEARANCE",
                                    prop: "appearanceDesc",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      disabled: !_vm.isSubmit,
                                      rules: _vm.formTableRules.appearanceDesc,
                                    },
                                    model: {
                                      value: _vm.formTable.appearanceDesc,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formTable,
                                          "appearanceDesc",
                                          $$v
                                        )
                                      },
                                      expression: "formTable.appearanceDesc",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.isSubmit
                            ? _c(
                                "div",
                                { staticClass: "toolsBox" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                      on: { click: _vm.addRowAppearance },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.addNewRow")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "danger" },
                                      on: { click: _vm.delRowAppearance },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.delRow")))]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-table",
                            {
                              ref: "AppearanceListRef",
                              attrs: {
                                data: _vm.formTable.AppearanceList,
                                border: "",
                                "span-method": _vm.objectSpanMethod,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection" },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "名称",
                                  prop: "title",
                                  "min-width": "170",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "AppearanceList." +
                                                  scope.$index +
                                                  ".title",
                                                rules: _vm.formTableRules.title,
                                              },
                                            },
                                            [
                                              _c(
                                                "el-popover",
                                                {
                                                  attrs: {
                                                    placement: "bottom",
                                                    width: "160",
                                                    trigger: "manual",
                                                  },
                                                  model: {
                                                    value: scope.row.visible,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "visible",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.visible",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    ref: "textarea",
                                                    attrs: {
                                                      slot: "reference",
                                                      type: "textarea",
                                                      rows: 1,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.handleInput(
                                                          scope.$index,
                                                          $event,
                                                          "APPEARANCE"
                                                        )
                                                      },
                                                    },
                                                    slot: "reference",
                                                    model: {
                                                      value: scope.row.title,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "title",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.title",
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "suggestions-box",
                                                    },
                                                    _vm._l(
                                                      ["Comments"],
                                                      function (
                                                        suggestion,
                                                        index
                                                      ) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticStyle: {
                                                              cursor: "pointer",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.selectSuggestion(
                                                                  suggestion,
                                                                  scope.$index,
                                                                  "APPEARANCE"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  suggestion
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1245599646
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "1",
                                  prop: "detail1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "AppearanceList." +
                                                  scope.$index +
                                                  ".detail1",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail1
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail1,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail1,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail1",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail1",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail1,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail1",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail1",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2753825919
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "2",
                                  prop: "detail2",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "AppearanceList." +
                                                  scope.$index +
                                                  ".detail2",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail2
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail2,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail2,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail2",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail2",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail2,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail2",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail2",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2525359772
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "3",
                                  prop: "detail3",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "AppearanceList." +
                                                  scope.$index +
                                                  ".detail3",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail3
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail3,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail3,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail3",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail3",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail3,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail3",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail3",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3552463293
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "4",
                                  prop: "detail4",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "AppearanceList." +
                                                  scope.$index +
                                                  ".detail4",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail4
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail4,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail4,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail4",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail4",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail4,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail4",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail4",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3248913114
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "5",
                                  prop: "detail5",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "AppearanceList." +
                                                  scope.$index +
                                                  ".detail5",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail5
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail5,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail5,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail5",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail5",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail5,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail5",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail5",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2054334203
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "6",
                                  prop: "detail6",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "AppearanceList." +
                                                  scope.$index +
                                                  ".detail6",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail6
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail6,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail6,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail6",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail6",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail6,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail6",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail6",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1825868056
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "7",
                                  prop: "detail7",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "AppearanceList." +
                                                  scope.$index +
                                                  ".detail7",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail7
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail7,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail7,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail7",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail7",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail7,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail7",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail7",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2852971577
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "8",
                                  prop: "detail8",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "AppearanceList." +
                                                  scope.$index +
                                                  ".detail8",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail8
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail8,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail8,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail8",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail8",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail8,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail8",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail8",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2468152150
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "9",
                                  prop: "detail9",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "AppearanceList." +
                                                  scope.$index +
                                                  ".detail9",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail9
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail9,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail9,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail9",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail9",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail9,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail9",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail9",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1273573239
                                ),
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _vm.queryCondition.showTexture
                      ? [
                          _c(
                            "div",
                            { staticClass: "table_title" },
                            [
                              _c("div", { staticClass: "table_title_sub c1" }, [
                                _vm._v("Texture"),
                              ]),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "appearanceDesc",
                                  attrs: {
                                    label: "TEXTURE/ MOUTHFEEL",
                                    prop: "textureDesc",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      disabled: !_vm.isSubmit,
                                      rules: _vm.formTableRules.textureDesc,
                                    },
                                    model: {
                                      value: _vm.formTable.textureDesc,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formTable,
                                          "textureDesc",
                                          $$v
                                        )
                                      },
                                      expression: "formTable.textureDesc",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.isSubmit
                            ? _c(
                                "div",
                                { staticClass: "toolsBox" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                      on: { click: _vm.addRowTexture },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.addNewRow")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "danger" },
                                      on: { click: _vm.delRowTexture },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.delRow")))]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-table",
                            {
                              ref: "TextureListRef",
                              attrs: {
                                data: _vm.formTable.TextureList,
                                border: "",
                                "span-method": _vm.objectSpanMethod,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection" },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "名称",
                                  prop: "title",
                                  "min-width": "170",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "TextureList." +
                                                  scope.$index +
                                                  ".title",
                                                rules: _vm.formTableRules.title,
                                              },
                                            },
                                            [
                                              _c(
                                                "el-popover",
                                                {
                                                  attrs: {
                                                    placement: "bottom",
                                                    width: "160",
                                                    trigger: "manual",
                                                  },
                                                  model: {
                                                    value: scope.row.visible,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "visible",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.visible",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    ref: "textarea",
                                                    attrs: {
                                                      slot: "reference",
                                                      type: "textarea",
                                                      rows: 1,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.handleInput(
                                                          scope.$index,
                                                          $event,
                                                          "TEXTURE"
                                                        )
                                                      },
                                                    },
                                                    slot: "reference",
                                                    model: {
                                                      value: scope.row.title,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "title",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.title",
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "suggestions-box",
                                                    },
                                                    _vm._l(
                                                      ["Comments"],
                                                      function (
                                                        suggestion,
                                                        index
                                                      ) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticStyle: {
                                                              cursor: "pointer",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.selectSuggestion(
                                                                  suggestion,
                                                                  scope.$index,
                                                                  "TEXTURE"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  suggestion
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3146831039
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "1",
                                  prop: "detail1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "TextureList." +
                                                  scope.$index +
                                                  ".detail1",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail1
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail1,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail1,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail1",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail1",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail1,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail1",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail1",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1921562846
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "2",
                                  prop: "detail2",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "TextureList." +
                                                  scope.$index +
                                                  ".detail2",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail2
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail2,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail2,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail2",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail2",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail2,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail2",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail2",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  385080093
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "3",
                                  prop: "detail3",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "TextureList." +
                                                  scope.$index +
                                                  ".detail3",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail3
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail3,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail3,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail3",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail3",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail3,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail3",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail3",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  796824924
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "4",
                                  prop: "detail4",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "TextureList." +
                                                  scope.$index +
                                                  ".detail4",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail4
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail4,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail4,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail4",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail4",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail4,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail4",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail4",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3218097819
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "5",
                                  prop: "detail5",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "TextureList." +
                                                  scope.$index +
                                                  ".detail5",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail5
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail5,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail5,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail5",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail5",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail5,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail5",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail5",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2877448922
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "6",
                                  prop: "detail6",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "TextureList." +
                                                  scope.$index +
                                                  ".detail6",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail6
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail6,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail6,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail6",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail6",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail6,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail6",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail6",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1340966169
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "7",
                                  prop: "detail7",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "TextureList." +
                                                  scope.$index +
                                                  ".detail7",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail7
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail7,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail7,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail7",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail7",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail7,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail7",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail7",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1752711000
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "8",
                                  prop: "detail8",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "TextureList." +
                                                  scope.$index +
                                                  ".detail8",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail8
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail8,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail8,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail8",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail8",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail8,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail8",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail8",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4210170007
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "9",
                                  prop: "detail9",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "TextureList." +
                                                  scope.$index +
                                                  ".detail9",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail9
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail9,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail9,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail9",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail9",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail9,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail9",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail9",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3869521110
                                ),
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _vm.queryCondition.showFlavor
                      ? [
                          _c(
                            "div",
                            { staticClass: "table_title" },
                            [
                              _c("div", { staticClass: "table_title_sub c1" }, [
                                _vm._v("Flavor"),
                              ]),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "appearanceDesc",
                                  attrs: {
                                    label: "AROMA/ FLAVOR",
                                    prop: "flavorDesc",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      disabled: !_vm.isSubmit,
                                      rules: _vm.formTableRules.flavorDesc,
                                    },
                                    model: {
                                      value: _vm.formTable.flavorDesc,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formTable,
                                          "flavorDesc",
                                          $$v
                                        )
                                      },
                                      expression: "formTable.flavorDesc",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.isSubmit
                            ? _c(
                                "div",
                                { staticClass: "toolsBox" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                      on: { click: _vm.addRowFlavor },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.addNewRow")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "danger" },
                                      on: { click: _vm.delRowFlavor },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.delRow")))]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-table",
                            {
                              ref: "FlavorListRef",
                              attrs: {
                                data: _vm.formTable.FlavorList,
                                border: "",
                                "span-method": _vm.objectSpanMethod,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection" },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "名称",
                                  prop: "title",
                                  "min-width": "170",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "FlavorList." +
                                                  scope.$index +
                                                  ".title",
                                                rules: _vm.formTableRules.title,
                                              },
                                            },
                                            [
                                              _c(
                                                "el-popover",
                                                {
                                                  attrs: {
                                                    placement: "bottom",
                                                    width: "160",
                                                    trigger: "manual",
                                                  },
                                                  model: {
                                                    value: scope.row.visible,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "visible",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.visible",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    ref: "textarea",
                                                    attrs: {
                                                      slot: "reference",
                                                      type: "textarea",
                                                      rows: 1,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.handleInput(
                                                          scope.$index,
                                                          $event,
                                                          "FLAVOR"
                                                        )
                                                      },
                                                    },
                                                    slot: "reference",
                                                    model: {
                                                      value: scope.row.title,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "title",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.title",
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "suggestions-box",
                                                    },
                                                    _vm._l(
                                                      ["Comments"],
                                                      function (
                                                        suggestion,
                                                        index
                                                      ) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticStyle: {
                                                              cursor: "pointer",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.selectSuggestion(
                                                                  suggestion,
                                                                  scope.$index,
                                                                  "FLAVOR"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  suggestion
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3276347904
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "1",
                                  prop: "detail1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "FlavorList." +
                                                  scope.$index +
                                                  ".detail1",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail1
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail1,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail1,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail1",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail1",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail1,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail1",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail1",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3215748385
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "2",
                                  prop: "detail2",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "FlavorList." +
                                                  scope.$index +
                                                  ".detail2",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail2
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail2,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail2,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail2",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail2",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail2,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail2",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail2",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1288633026
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "3",
                                  prop: "detail3",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "FlavorList." +
                                                  scope.$index +
                                                  ".detail3",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail3
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail3,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail3,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail3",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail3",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail3,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail3",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail3",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3486617699
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "4",
                                  prop: "detail4",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "FlavorList." +
                                                  scope.$index +
                                                  ".detail4",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail4
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail4,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail4,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail4",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail4",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail4,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail4",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail4",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3805665284
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "5",
                                  prop: "detail5",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "FlavorList." +
                                                  scope.$index +
                                                  ".detail5",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail5
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail5,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail5,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail5",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail5",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail5,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail5",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail5",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1797820581
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "6",
                                  prop: "detail6",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "FlavorList." +
                                                  scope.$index +
                                                  ".detail6",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail6
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail6,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail6,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail6",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail6",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail6,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail6",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail6",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4165672518
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "7",
                                  prop: "detail7",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "FlavorList." +
                                                  scope.$index +
                                                  ".detail7",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail7
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail7,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail7,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail7",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail7",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail7,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail7",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail7",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2068689895
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "8",
                                  prop: "detail8",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "FlavorList." +
                                                  scope.$index +
                                                  ".detail8",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail8
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail8,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail8,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail8",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail8",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail8,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail8",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail8",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3274791816
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "show-overflow-tooltip": "",
                                  label: "9",
                                  prop: "detail9",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "FlavorList." +
                                                  scope.$index +
                                                  ".detail9",
                                              },
                                            },
                                            [
                                              !_vm.isSubmit && scope.row.detail9
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      staticClass: "item",
                                                      attrs: {
                                                        content:
                                                          scope.row.detail9,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-input",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.isSubmit,
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.detail9,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "detail9",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.detail9",
                                                          },
                                                        },
                                                        [_vm._v(" ")]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "el-input",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.isSubmit,
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.detail9,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "detail9",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.detail9",
                                                      },
                                                    },
                                                    [_vm._v(" ")]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1266947113
                                ),
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "模板产品明细", name: "second" } },
              [
                _c(
                  "el-table",
                  { attrs: { data: _vm.materialsList, border: "", fit: "" } },
                  [
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        prop: "fiveBitCode",
                        label: _vm.$t("sensory.template.productNumber"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        prop: "fiveBitCodeName",
                        label: _vm.$t("sensory.template.productName"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        prop: "version",
                        label: _vm.$t(
                          "sensory.template.productTemplateVersionNumber"
                        ),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row.version == null
                                      ? ""
                                      : "V" + scope.row.version
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        prop: "isActive",
                        formatter: _vm.formatActive,
                        label: _vm.$t("sensory.template.isEffective"),
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.ttSensoryTemplateId
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("common.approvalLog"),
                      name: "third",
                    },
                  },
                  [
                    _c(
                      "el-table",
                      { attrs: { data: _vm.logList, border: "", fit: "" } },
                      [
                        _c("el-table-column", {
                          attrs: {
                            "show-overflow-tooltip": "",
                            prop: "createDate",
                            label: _vm.$t("common.OperationTime"),
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFormatFilter")(
                                          scope.row.createDate,
                                          "YYYY-MM-DD HH:mm:ss"
                                        )
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3398165263
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            "show-overflow-tooltip": "",
                            prop: "operatorName",
                            label: _vm.$t("common.OperatorName"),
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            "show-overflow-tooltip": "",
                            prop: "action",
                            label: _vm.$t("common.PedagogicalOperation"),
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            "show-overflow-tooltip": "",
                            prop: "comments",
                            label: _vm.$t("common.remarks"),
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: { title: "审批拒绝", visible: _vm.refuseVisible },
            on: {
              "update:visible": function ($event) {
                _vm.refuseVisible = $event
              },
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "refuseForm",
                attrs: {
                  model: _vm.refuseForm,
                  rules: _vm.refuseFormRules,
                  inline: "",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "请填写拒绝原因 ",
                      "label-width": "120",
                      prop: "comments",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { maxlength: "300" },
                      model: {
                        value: _vm.refuseForm.comments,
                        callback: function ($$v) {
                          _vm.$set(_vm.refuseForm, "comments", $$v)
                        },
                        expression: "refuseForm.comments",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.refuseVisible = false
                      },
                    },
                  },
                  [_vm._v("取 消")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.refuse("refuseForm")
                      },
                    },
                  },
                  [_vm._v("确 定")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.showTemplateNameDialog,
              width: "80%",
              title: "产品选择器",
            },
            on: {
              "update:visible": function ($event) {
                _vm.showTemplateNameDialog = $event
              },
            },
          },
          [
            _c("PickupFiveBitCode", {
              attrs: { multi: true },
              on: { pickup: _vm.selectTemplateName },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.showUserDialog,
              width: "80%",
              title: "模板审批人选择器",
            },
            on: {
              "update:visible": function ($event) {
                _vm.showUserDialog = $event
              },
            },
          },
          [_c("PickupUser", { on: { input: _vm.selectUserData } })],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }